module.exports = __webpack_public_path__ + "img/top-about-laptop.0c638729.jpg";